import {VGNav} from "vgnav";
import Swiper from 'swiper';
import {VGLawCookie} from "vglawcookie";

const VGListener = {
	onReady: () => {
		VG.defaults();
		VG.plugins.init();
		VG.ScrollToTop.init($(window));
		VG.ScrollHeader.init($(window));
		VG.ScrollSlider.init($(window));

		// [vegas]
		VG.log();
		VG.animationSlider();
	},

	onLoad: () => {

	},

	onScroll: ($self) => {
		VG.ScrollToTop.setPosition($self);
		VG.ScrollHeader.init($self);
	},

	onResize: ($self) => {

	},
};

const VG = {
	log: function (errors = []) {
		if (!errors.length) {
			console.log("%cVG app was initialization", "color: green;");
		} else {
			errors.forEach(function (item) {
				console.error(item);
			});
		}
	},

	ScrollSlider: {
		swiperInit: false,

		init: function ($window) {
			let $slider = $('#swiper-slider');

			if (!this.swiperInit) {
				setTimeout(() => {
					VG.ScrollSlider.scrolling($slider, $window);
					this.swiperInit = true;
				}, 100);
			} else {
				VG.ScrollSlider.scrolling($slider, $window);
			}
		},

		scrolling: function ($slider, $window) {
			if ($slider.length) {
				let swiper = $slider.get(0).swiper;
				let scrollDisabled = false;
				let scrollTop = $window.scrollTop();

				scroller.init(function () {
					if (scrollDisabled) {
						scrollDisabled = false;
						swiper.slideNext();
						setTimeout(function () {
							scroller.enableScroll();
						}, 1000);
					}
				});

				if (swiper.realIndex === 0 && scrollTop <= 10) {
					scroller.disableScroll();
					scrollDisabled = true;
				}
			}
		}
	},

	animationSlider: () => {
		const slider = document.querySelectorAll('.slider .slider-item-other');
		const classToggle = (target, parent) => {
			if (target.classList.contains('right')) {
				parent.classList.add('right');
				parent.classList.remove('left');
			} else if (target.classList.contains('left')) {
				parent.classList.remove('right');
				parent.classList.add('left');
			}
		};
		if(slider) {
			let btnArr = [];
			slider.forEach((el) => {
				let btn = el.querySelectorAll('.choiceBtn');
				if(btn) {
					for(let item of btn) {
						btnArr.push(item);
					}
				}
			});
			if(btnArr.length) {
				btnArr.forEach((el) => {
					el.addEventListener('mouseover', (e) => {
						let target = e.target;
						let parent = target.closest('.slider-item-other');
						classToggle(target, parent);
					});

					el.addEventListener('mouseout', (e) => {
						let target = e.target;
						let parent = target.closest('.slider-item-other');
						parent.classList.remove('right', 'left');
					})
				});
			}
		}
	},

	defaults: () => {
		// Манипуляции с контентом по умолчанию
		$('.vg-page-default, .page-default').each(function () {
			let $self = $(this);

			// Table
			let $table = $self.find('table');
			$table.addClass('table table-hover table-bordered');
			$table.wrap('<div class="table-responsive"></div>');

			// image
			$self.find('img').addClass('img-fluid');
			$self.find('figure.image_resized > img, img.image_resized').each(function (i, e) {
				let src = $(e).attr('src');
				$(e).wrap('<a style="display: inline-block" href="'+src+'" data-fancybox></a>');
			});
			fbx.Fancybox.bind($self.find('[data-fancybox]'));

			// AOS
			if (enables.scrollAnimation) {
				if (typeof $self.attr('data-aos-start') !== typeof undefined && $self.attr('data-aos-start') !== false) {
					let $tags = ['p', 'li', 'h2', 'h3'],
						start = parseInt($self.data('aos-start')),
						step = 100;

					for (let i = 1; i <= $tags.length; i++) {
						let tag = $tags[i - 1],
							$tag = $self.find(tag);

						if ($tag.length) {
							$.each($tag, function () {
								start = start + step;
								$(this).attr('data-aos', 'fade-up');
								$(this).attr('data-aos-delay', start);
							});
						}
					}

					AOS.init();
				}
			}

		});
	},

	plugins: {
		init: () => {
			VG.plugins.enableAOS();
			VG.plugins.enableNiceSelect();
			VG.plugins.enableVGNav();
			VG.plugins.enableLawCookie();
		},

		enableVGNav: function () {
			new VGNav({
				expand: 'lg',
				toggle: '<i class="fa fa-chevron-down"></i>',
			});
		},

		enableAOS: function () {
			if (enables.scrollAnimation) {
				AOS.init({once: true});
			}
		},

		enableNiceSelect: function () {
			$('.nice-select').niceSelect();
		},

		enableLawCookie: function () {
			new VGLawCookie({
				enableLinkMore: true,
			});
		}
	},

	ScrollToTop: {
		posActive: 400,
		btn: 'btn-scroll-to-top',

		init: function ($window) {
			let $layoutScrollToTop = $('#' + this.btn);

			if (!$layoutScrollToTop.length) {
				$('body').append('<div class="to-top" id="' + this.btn + '"><span><i class="fal fa-chevron-up"></i></span></div>')

				this.setPosition($window);
			}

			let $btnScrollToTop = $('#' + this.btn + ' span');
			$btnScrollToTop.click(function () {
				window.scrollTo(0, 0);

				return false;
			});
		},

		setPosition: function ($window) {
			let $sticky = $('#' + this.btn),
				scroll = $window.scrollTop();

			if (scroll >= this.posActive) {
				$sticky.addClass('is-active');
			} else {
				$sticky.removeClass('is-active');
			}
		}
	},

	ScrollHeader: {
		lastScrollTop: 0,
		body: $('body'),

		init: function ($window) {
			let $sticky = $('.header-wrapper'),
				scroll = $window.scrollTop();

			if (scroll > 0) {
				this.body.addClass('header--is-scroll');
				$sticky.addClass('scroll');

				if (scroll > this.lastScrollTop) {
					$sticky.removeClass('fixed');
					this.body.removeClass('header--is-fixed');
				} else {
					$sticky.addClass('fixed');
					this.body.addClass('header--is-fixed');
				}

				this.lastScrollTop = scroll;
			} else if (scroll === 0) {
				$sticky.removeClass('scroll').removeClass('fixed');
				this.body.removeClass('header--is-scroll header--is-fixed');
			}

			// reviews form scroll
			let $reviews = $('.catalog-reviews--form');
			if ($reviews.length) {
				if(this.body.hasClass('header--is-fixed')) {
					$reviews.css('top', 145);
				} else {
					$reviews.css('top', 70);
				}
			}
		},
	}
}


export default VGListener;
